module.exports = __webpack_public_path__ + "static/media/6.8.6f684ff7.zip";